export default "__VITE_ASSET__9900ebd2__"